import gql from 'graphql-tag'

export const fetchProductWishlistQuery = gql`
{
    products(
      filter:{},
      pageSize: 4,
      currentPage:1,
      sort: {}) {
      total_count
      items {
        name
        sku
        product_name_sap
        __typename
        description{
            html
        }
        ean
        ean_ea
        your_price
        your_price_tax
        downloads
        favourites
        promo
      weight
      gross_weight_for_one_cas
      pallet_weight
      packaging
      number_of_layers_per_pallet
      product_name_sap
      brand
      number_of_items_in_box
      number_of_items_on_pallet
      number_of_products_on_layer
      pack_format
      sub_brand
      volume
      name
      filter_packaging
      product_last
      product_new
      product_sale
      product_recommended
      url_key
      small_image {
        url
      }
      cart_fields {
        packaging_cart
        layer_cart
        pallets_cart
      }
      image {
        url
      }
      media_gallery {
        url
      }
  ... on BundleProduct {
          items {
            title
            sku
            type
            required
            position
            your_price_sum
            options {
              id
              label
              quantity
              price
              price_type
              position
              product {
                id
                name
                sku
                your_price
                __typename
              }
            }
          }
        }
      }
      page_info {
        page_size
        total_pages
        current_page
      }
    }
  }`
